<template lang="pug">
div
    //- ResultsNavigation
    div(v-if="$store.state['search'].showNoResultText" style="margin: 20vh 0 25vh 0" class="text-center")
      p No results for your search
    v-list(v-else)
      ResultItem(
        v-for="(result, index) in results"
        :item="result"
        :key="result.id" 
        :showFullCard="false"
        class="m-2"
      )
        template(v-if="selectableItems" #append-item-title)
          v-checkbox(
            :id="`${result.id}_${index}`"
            :disabled="isRelationDisabled(result.id)"
            :input-value="isRelationSelected(result.id)"
            @change="toggleSelectedSearchItems({result, totalSelectableItems})"
          )
    
</template>

<script>
import { mapActions, mapState } from "vuex";
import ResultItem from "@/components/search/SearchResultItem.vue";
// import ResultsNavigation from "@/components/search/SearchResultsNavigation.vue";
export default {
  props: {
    selectableItems: {
      type: Boolean,
      default: false,
    },
    totalSelectableItems: {
      type: Number,
      default: null,
    },
  },
  data: () => ({}),
  components: {
    ResultItem,
    // ResultsNavigation,
  },
  computed: {
    ...mapState("search", ["results", "selectedSearchItems"]),
  },
  methods: {
    ...mapActions("search", ["toggleSelectedSearchItems"]),
    isRelationSelected(id) {
      const index = this.selectedSearchItems.map((item) => item.id).indexOf(id);
      if (index >= 0) {
        return true;
      }
      return false;
    },
    isRelationDisabled(id) {
      const index = this.selectedSearchItems.map((item) => item.id).indexOf(id);
      if (index >= 0) {
        return false;
      }
      if (!this.totalSelectableItems) return false;
      const canSelectNewValues =
        this.selectedSearchItems.length < this.totalSelectableItems;
      return !canSelectNewValues;
    },
  },
};
</script>
